import { z } from "zod";
import { COLORS } from "../../colors";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const wikiSpaceSchema = z.object({
	name: z.string().min(1, "Name is required"),
	description: ZodStringNullable,
	visibility: z.enum(["public", "private", "restricted"]).default("public"),
	color: z.enum(COLORS).default("blue"),
});

export type WikiSpaceSchema = z.infer<typeof wikiSpaceSchema>;
